import React from 'react';
import PropTypes from 'prop-types';

import { lessonsWord } from '../../utils/lessonsWord';

const CourseProgress = ({ total, passed, left, compact }) => {
  if (!total) {
    return null;
  }

  const percent = Math.min(100, Math.round((passed / total) * 100));

  return (
    <div className={`v2-progress ${compact ? 'v2-progress--compact' : ''}`.trim()}>
      <div className="v2-progress__top">
        <span className="v2-progress__left">
          {left > 0
            ? <>До завершення курсу залишилося <b>{left} {lessonsWord(left)}</b></>
            : <b>Курс пройдено повністю</b>}
        </span>
        <span className="v2-progress__count">{passed} із {total}</span>
      </div>
      <span className="v2-progress__track"><i style={{ width: `${percent}%` }}></i></span>
      <span className="v2-progress__note">{percent}% курсу пройдено</span>
    </div>
  );
};

CourseProgress.propTypes = {
  total: PropTypes.number,
  passed: PropTypes.number,
  left: PropTypes.number,
  compact: PropTypes.bool,
};

CourseProgress.defaultProps = {
  total: 0,
  passed: 0,
  left: 0,
  compact: false,
};

export default CourseProgress;
